__webpack_require__.p = "https://www.highsnobiety.com/static-assets/interactive-stories/2026-02-jordan/";